import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Organization, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  organization: Identifiable<Organization>;
  retrieveOrganization(
    credentials: Boundaries["retrieveOrganization"]["request"],
  ): void;
}

function useRetrieveOrganization(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveOrganizationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveOrganizationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveOrganizationRequestFailure(planzone),
    ),
    organization: useSelector(() => selector.getOrganization(planzone)),
    retrieveOrganization: core.retrieveOrganization,
  };
}

export { useRetrieveOrganization };
